import classNames from "classnames";
import { differenceInYears, format } from "date-fns";
import locale from "date-fns/locale/nb";
import type Show from "@/lib/types/Show";
import Link from "next/link";
import { useCallback } from "react";
import styles from "./TicketButton.module.css";




//#region [Props]
export type TicketButtonProps = {
    show: Show;
    className?: string;
    showDate?: boolean;
    showPassed?: boolean;
    appendShowType?: boolean;
};
//#endregion

const excludeTags: string[] = ["Norsk tekst", "2D"];


//#region [Component]
export default function TicketButton({ show, className, appendShowType = false, showDate = false, showPassed = false }: TicketButtonProps) {
    const gtmHandler = useCallback(() => {
        gtmEvent(show);
    }, [show]);

    if (!showPassed && !show.ticketSaleUrl) {
        return null;
    }



    /*
    let metaInfo: string[] = [];
    const is4DX = show.versionTags?.find(({ tag }) => tag === '4DX') ? true : false;
    const is3D = show.versionTags?.find(({ tag }) => tag === '3D') ? true : false;
    const norskTale = show.versionTags?.find(({ tag }) => tag === 'Norsk tale') ? true : false;
    const originalTale = show.versionTags?.find(({ tag }) => tag === 'Original tale') ? true : false;
    const samiskTale = show.versionTags?.find(({ tag }) => tag === 'Samisk tale') ? true : false;
    const isAtmos = show.versionTags?.find(({ tag }) => tag === 'Atmos') ? true : false;
    const isUtekstet = show.versionTags?.find(({ tag }) => tag === 'Utekstet') ? true : false;
    */
    const versionTags = show.versionTags?.filter(({ tag }) => !excludeTags.includes(tag)) ?? [];
    versionTags.sort((a, b) => {
        if (a.tag.endsWith(" tale") && !b.tag.endsWith(" tale")) {
            return -1;
        }
        if (!a.tag.endsWith(" tale") && b.tag.endsWith(" tale")) {
            return 1;
        }

        if (a.tag.includes("tekst") && !b.tag.includes("tekst")) {
            return 1;
        }
        if (!a.tag.includes("tekst") && b.tag.includes("tekst")) {
            return -1;
        }
        return 0;
    });

    /*
    if (norskTale) metaInfo.push("Norsk tale");
    if (originalTale) metaInfo.push("Original tale");
    if (samiskTale) metaInfo.push("Samisk tale");
    if (isAtmos) metaInfo.push("Atmos");
    if (is4DX) metaInfo.push("4DX");
    if (is3D) metaInfo.push("3D");
    if (isUtekstet) metaInfo.push("Utekstet");
    */

    const versionText = versionTags.length === 0 ? "\u00A0" : versionTags.map(t => t.tag).join(", ");

    const presentableTime = format(show.showStartDate, 'HH:mm', { locale });

    const ariaLabel = [];
    if (showDate) {
        ariaLabel.push(format(show.showStartDate, 'eeee dd.MM.yyyy', { locale }));
    }
    ariaLabel.push(show.screenName)
    ariaLabel.push(presentableTime);
    ariaLabel.push(versionText);
    if (appendShowType && show.showType) {
        ariaLabel.push(show.showType);
    }

    const displayFormat = differenceInYears(show.showStartDate, new Date()) >= 1 ? "eee dd.MM.yyyy" : "eeee dd.MM";
    const isPassed = !show.ticketSaleUrl;

    return <Link href={show.ticketSaleUrl ?? "#"} className={classNames(styles.ShowLink, isPassed ? styles.ShowLink_isPassed : null, className)} aria-label={ariaLabel.join(' ').trim()} data-edi={show.movieVersionId} target="_blank" onClick={gtmHandler}>
        {showDate && <time className={classNames(styles.Time, styles.Date, "showDate")} dateTime={format(show.showStartDate, 'yyyy-MM-dd', { locale })}>{format(show.showStartDate, displayFormat, { locale })}</time>}
        <span className={classNames(styles.MetaInfo, styles.MetaInfo_uppercase, isPassed ? styles.IsPassed : null)} >{show.screenName}</span>
        <time dateTime={presentableTime} className={classNames(styles.Time, isPassed ? styles.IsPassed : null)} >{presentableTime}</time>
        <span className={classNames(styles.MetaInfo, styles.MetaInfo_scaleDownMobile, isPassed ? styles.IsPassed : null)} >{versionText}{appendShowType && show.showType && versionTags.length > 0 && ', '}{appendShowType && show.showType && <span >{show.showType}</span>}</span>

    </Link>
}
//#endregion


//#region [Other]
function gtmEvent(show: Show): void {
    if (window?.dataLayer) {
        //console.debug("EDI", show.movieVersionId);
        //console.debug("Title", show.movieTitle);

        window?.dataLayer?.push({
            'event': 'Billettsalg',
            'eventCategory': 'Billettsalg',
            'eventAction': "AddToCart",
            'eventLabel': show.movieTitle,
            'eventEdi': show.movieVersionId
        });
    }

}
//#endregion